<template>
  <div class="loader-back" unselectable="on">
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td width="40%" align="center"></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="info-message">{{ message }}</div>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" id="btn_back" src="/imgs/back_1.png">
        </td>
        <td width="40%" align="center">
        </td>
        <td width="30%" align="right">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "MessageBox",
  props: ['message', 'onClose'],
  methods: {
    backClick() {
      this.onClose()
    }
  }
}
</script>

<style scoped>

.loader-back {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  z-index: 9999;
  background-color: #F5F5F5;
  padding: 20px;
}

.info-message {
  font-size: 36px;
  word-wrap: anywhere;
}
</style>
